export const ExperienceData = [
  {
    id: 1,
    title: "Salesforce Developer",
    company: "TCS",
    date: "April 2024 - Present",
    duration: "Present",
    skills: [
      "Salesforce Apex",
      "Lightning Web Components (LWC)",
      "Salesforce Administration",
      "Copado",
      "SOQL & SOSL",
      "REST & SOAP APIs",
      "Data Cloud",
    ],
    icon: "cloud",
  },
  {
    id: 2,
    title: " Software Engineer Trainee → Full Stack Developer",
    company: "Robro Systems",
    date: "May 2023 - April 2024",
    duration: "1 yr",
    skills: [
      "Artificial Intelligence (AI)",
      "Machine Learning",
      "Back-End Web Development",
      "Customer Service",
      "Front-end Development",
    ],
    icon: "briefcase",
  },
  {
    id: 3,
    title: "Student Research Associate",
    company: "Indian Institute of Technology, Kanpur",
    date: "Aug 2022 - Sep 2022",
    duration: "2 mos",
    skills: ["Node.js", "Flask", "Bootstrap", "HTML", "CSS"],
    icon: "python",
  },
  {
    id: 4,
    title: "React Developer",
    company: "Payonetime",
    date: "May 2022 - Jul 2022",
    duration: "3 mos",
    skills: ["Node.js", "React.js", "JavaScript"],
    icon: "react",
  },
  {
    id: 5,
    title: "Freelance Web Developer",
    company: "CodiPhi Solutions",
    date: "Feb 2022 - May 2022",
    duration: "4 mos",
    skills: ["Node.js", "SQL", "Vue.js", "JavaScript"],
    icon: "file",
  },
  {
    id: 6,
    title: "Full Stack Developer",
    company: "Cantilever Labs",
    date: "Dec 2021 - Mar 2022",
    duration: "4 mos",
    skills: [
      "Node.js",
      "Data Structures",
      "SQL",
      "React.js",
      "Bootstrap",
      "MongoDB",
      "Google Analytics",
      "JavaScript",
    ],
    icon: "javascript",
  },
  {
    id: 7,
    title: "Frontend Developer",
    company: "Tech Tomatoes",
    date: "Jun 2021 - Aug 2021",
    duration: "3 mos",
    skills: ["ReactJs", "React-Bootstrap", "UI/UX Design"],
    icon: "laptop",
  },
];